import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import Input from '../../../../../components/forms/Input'
import Select from '../../../../../components/forms/Select'
import SimpleDatePicker from '../../../../../components/forms/SimpleDatePicker'
import { SANDRE } from '../../../../../referencial/constants/ReferencialConstants'
import { getSandreList } from '../../../../../utils/StoreUtils'
import DtoCodificationContributor from '../../../../dto/DtoCodificationContributor'
import DtoSandreCode from '../../../../dto/DtoSandreCode'
import { Grid } from '@mui/material'

class CodificationModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            codification: { ...props.codification, idContributor: props.id },
        }
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.popupIsOpen && this.props.popupIsOpen) {
            $('#descriptionModal').on('click', this.onSave)
        }
    }
    onSave = () => {
        this.props.saveResult(new DtoCodificationContributor(this.state.codification))
        $('.modal').modal('close')
    }

    onChangeElement = (changes) => this.setState({ codification: { ...this.state.codification, ...changes } })

    render() {
        const { codification } = this.state
        return (
            <div>
                <Grid container spacing={1}>
                    <Grid size={6}>
                        <SimpleDatePicker
                            id='startDate'
                            label={i18n.startDate}
                            value={codification.startDate}
                            onChange={(v) => this.onChangeElement({ startDate: v })}
                        />
                    </Grid>
                    <Grid size={6}>
                        <SimpleDatePicker
                            id='endDate'
                            label={i18n.endDate}
                            value={codification.endDate}
                            onChange={(v) => this.onChangeElement({ endDate: v })}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={1} sx={{ paddingTop: 1 }}>
                    <Grid size={6}>
                        <Select
                            label={ i18n.codificationType }
                            value={ codification.codificationType }
                            options={ getSandreList(this.props.sandreCodes, SANDRE.INTERVENANTS_TYPE_CODIFICATION)}
                            keyvalue='code'
                            integerValue
                            onChange={ v => this.onChangeElement({ codificationType: v }) }
                        />
                    </Grid>
                    <Grid size={6}>
                        <Input title={ i18n.codification } value={ codification.codification } onChange={ v => this.onChangeElement({ codification: v }) } />
                    </Grid>
                </Grid>
            </div>
        )
    }
}

CodificationModal.propTypes = {
    codification: PropTypes.instanceOf(DtoCodificationContributor),
    id: PropTypes.number,
    sandreCodes: PropTypes.arrayOf(PropTypes.instanceOf(DtoSandreCode)),
    popupIsOpen: PropTypes.bool,
    saveResult: PropTypes.func,
}


const mapStateToProps = store => ({
    sandreCodes: store.ReferencialReducer.sandreCodes,
    popupIsOpen: store.SieauReducer.popupIsOpen,
})

CodificationModal.defaultProps = {
    contributor: {},
}

export default connect(mapStateToProps)(CodificationModal)
